import React from 'react';

// Renders structured legal content (see data/legal.js) as accessible HTML.
// Auto-links the company email, phone and any https URL. Preserves line breaks.
const linkClass = 'text-blue-700 hover:text-blue-800 font-medium break-words';

const linkify = (text) => {
  const regex = /(office@newchem\.org|https?:\/\/[^\s]+|\+43 2252 45 970)/g;
  const out = [];
  let last = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const tok = m[0];
    if (tok.includes('@')) {
      out.push(<a key={i++} href={`mailto:${tok}`} className={linkClass}>{tok}</a>);
    } else if (tok.startsWith('http')) {
      out.push(<a key={i++} href={tok} target="_blank" rel="noopener noreferrer" className={linkClass}>{tok}</a>);
    } else {
      out.push(<a key={i++} href="tel:+43225245970" className={linkClass}>{tok}</a>);
    }
    last = m.index + tok.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
};

const LegalBody = ({ blocks }) => (
  <div className="space-y-5 text-[15px] text-slate-700 leading-relaxed">
    {blocks.map((b, i) => {
      if (b.t === 'h2') {
        return <h2 key={i} className="text-[18px] font-bold text-slate-900 pt-4">{b.text}</h2>;
      }
      if (b.t === 'h3') {
        return <h3 key={i} className="text-[15px] font-bold text-slate-900 pt-1">{b.text}</h3>;
      }
      if (b.t === 'ul') {
        return (
          <ul key={i} className="list-disc pl-5 space-y-1">
            {b.items.map((it, j) => <li key={j}>{linkify(it)}</li>)}
          </ul>
        );
      }
      return <p key={i} className="whitespace-pre-line">{linkify(b.text)}</p>;
    })}
  </div>
);

export default LegalBody;
